<template>
	<div class="content" style="background-color: #103037; border-radius: 15px;padding: 20px 0px">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-10 md-medium-size-20 md-size-33"></div>
			<div class="md-layout-item md-small-size-80 md-medium-size-60 md-size-33">
				<loading v-if="!loaded" />
				<div class="form__tabs__wrap" v-if="loaded">
					<form @submit.prevent="login()">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input type="text" v-model="user.username" :placeholder="$store.state.lang.text.username[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.password" type="password" :placeholder="$store.state.lang.text.password[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100" style="margin-top: 10px;">
								<div class="create__btn"><a class="cmn--btn" @click="login()"><span>{{$store.state.lang.text.login[$store.state.lang.language]}}</span></a></div>
							</div>
							<!-- <div class="md-layout-item md-small-size-70 md-medium-size-70 md-size-70">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.verification_code" type="password" :placeholder="$store.state.lang.text.security_number[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-30 md-medium-size-30 md-size-30" style="display: flex; justify-content: center;align-items: center;margin-top: 18px">{{user.code}}</div> -->
							<!-- <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100" style="display: flex; justify-content: center;align-items: center;margin-top: 18px">{{message}}</div> -->
						</div>

					</form>
			   </div>
			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		mounted() {
			window.scrollTo(0,0);
		},
		created() {

			if(this.$store.state.authentication.loggedIn) {
				this.$router.push("/");
			}  else {
				this.getForm();
			}
		},
		methods: {
			getForm() {
				this.$http.get(this.config.api + "/user/request_form").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user.token = res.body.data.token
						this.user.code = res.body.data.code
						this.user.verification_code = res.body.data.code
					}
				})
			},
			login() {
				if(this.user.username.length > 3 && this.user.password.length > 4) {
					this.$http.post(this.config.api + "/user/login", {
						username: this.user.username,
						password: this.user.password,
						token: this.user.token,
						verification_code: this.user.verification_code
					}).then(res => {

						if (res.body.status == 'success') {
							this.$store.state.authentication.loggedIn = true;
							this.$store.state.authentication.authToken = res.body.data.token;
							this.$cookie.set('auth', res.body.data.token, 1);
							this.$router.push("/");
						} else {
							this.user.password = ""
							// this.user.verification_code = ""
							this.getForm();
						}
					})
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}
			},
		},
		computed: {
		},
		data() {
			return {
				isValid: false,
				loaded: false,
				message: "",
				user: {username: "", password: "", token: "", verification_code: "", code: ""}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue